import { Component, OnInit, ChangeDetectorRef, NgModule } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '../../../translate';
import { SetupFamilyService } from '../setup-family.service';
import { AppService } from '../../../app.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { LoadingService } from '../../../shared/services/loading.service';
import { heicTo } from 'heic-to';
@Component({
  selector: 'app-setup-family',
  templateUrl: './setup-family.component.html',
  styleUrls: ['./setup-family.component.scss'],

})

// @NgModule({
//   providers: [ SetupFamilyService ]
// })
export class SetupFamilyComponent implements OnInit {

  translateSubscription: Subscription;
  userLanguage: string = "english";

  type_auto: number
  FamilyName: string
  FamilyID: string
  blob_auto: number
  family: number


  FamilyImage_Frame: string
  FamilyImage_Chain: string
  ModelImage_fromPC_F: string
  ModelImage_fromPC_C: string
  selectedFile_F: File
  selectedFile_C: File

  isNew: boolean = true
  ShowDistTravelledTracking: boolean;
  ShowPropelHrsPerc: boolean;
  ShowEqualiserBarType: boolean;
  ShowTrackIntensionIndicator: boolean;
  userName
  showFrameConfiguration: boolean = false;
  showCannonType: boolean = false;
  showBogieShim: boolean = false;
  showManualInspection: boolean = false;
  showTrackSag: boolean = false;
  showCannonExt: boolean = false;
  showScallop: boolean = false;
  showDryJoints: boolean = false;
  showNumberOfLinks: boolean = false;
  showUnderFootConditions: boolean = false;
  showWorkOrder: boolean = false;
  showThermalImage: boolean = false;
  showAdditionalInspectors: boolean = false;

  constructor(private _translate: TranslateService,
    private ref: ChangeDetectorRef,
    private _appService: AppService,
    public setupFamilyService_: SetupFamilyService,
    private _sanitizer: DomSanitizer,
    private _notify: NotificationsService,
    private _loading: LoadingService) {
  }

  ngOnInit() {
    console.log("oninit")
    this._appService.setPageTitle('Setup Family');
    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
    this.setupFamilyService_.getFamilyList();
    console.log("this.availableFamilyList: ", this.setupFamilyService_.availableFamilyList);
    this.setupFamilyService_.getFamilyImageList();
    this._appService.GetLoggedInUserName().subscribe(result => { this.userName = result; });
  }

  ngOnDestroy() {
    this.translateSubscription.unsubscribe();
  }

  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this.ref.detectChanges();
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  loadFamilyDetails(value: number) {
    this.type_auto = value
    this.setupFamilyService_.availableFamilyList.map(x => {
      if (x.type_auto == value) {
        this.FamilyID = x.typeid
        this.FamilyName = x.typedesc
        this.blob_auto = x.blob_auto
        this.isNew = false
        this.FamilyImage_Chain = x.ChainImage
        this.FamilyImage_Frame = x.FrameImage
        this.ShowDistTravelledTracking = x.ShowDistTravelledTracking;
        this.ShowPropelHrsPerc = x.ShowPropelHrsPerc;
        this.ShowEqualiserBarType = x.ShowEqualiserBarType
        this.ShowTrackIntensionIndicator = x.ShowTrackIntensionIndicator
        this.showFrameConfiguration = x.ShowFrameConfiguration;
        this.showCannonType = x.ShowCannonType;
        this.showBogieShim = x.ShowBogieShim;
        this.showManualInspection = x.ShowManualInspection;
        this.showTrackSag = x.ShowTrackSag;
        this.showCannonExt = x.ShowCannonExt;
        this.showScallop = x.ShowScallop;
        this.showDryJoints = x.ShowDryJoints;
        this.showNumberOfLinks = x.ShowNumberOfLinks;
        this.showUnderFootConditions = x.ShowUnderFootConditions;
        this.showWorkOrder = x.ShowWorkOrder;
        this.showThermalImage = x.ShowThermalImage;
        this.showAdditionalInspectors = x.ShowAdditionalInspectors;
      }
      if (value == 0) {
        this.FamilyID = ""
        this.FamilyName = ""
        this.blob_auto = 0
        this.FamilyImage_Chain = ""
        this.FamilyImage_Frame = ""
        this.isNew = true
        this.ShowDistTravelledTracking = false;
        this.ShowPropelHrsPerc = false;
        this.ShowEqualiserBarType = false;
        this.ShowTrackIntensionIndicator = false;
        this.showFrameConfiguration = false;
        this.showCannonType = false;
        this.showBogieShim = false;
        this.showManualInspection = false;
        this.showTrackSag = false;
        this.showCannonExt = false;
        this.showScallop = false;
        this.showDryJoints = false;
        this.showNumberOfLinks = false;
        this.showUnderFootConditions = false;
        this.showWorkOrder = false;
        this.showThermalImage = false;
        this.showAdditionalInspectors = false;
      }
    })
  }

  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }
  //Uplaod Image for Frame
  // onSelectFrame(event: any) {
  //   if (event.target.files && event.target.files[0]) {
  //     var reader = new FileReader();
  //     this.selectedFile_F = event.target.files[0];
  //     reader.onloadend = (e) => {
  //       this.uploadPhotoFrame(reader.result as string);
  //     }
  //     reader.readAsDataURL(event.target.files[0]);
  //   }
  // }


// onSelectFrame(event: any) {
//   if (event.target.files && event.target.files[0]) {
//     let file = event.target.files[0];
//     const isHeic =
//       file.type === "image/heic" ||
//       file.name.toLowerCase().endsWith(".heic");
//     const processFile = (f: File) => {
//       this.selectedFile_F = f;
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         this.uploadPhotoFrame(reader.result as string);
//       };
//       reader.readAsDataURL(f);
//     };
//     if (isHeic) {
//       (heic2any as any).default({
//         blob: file,
//         toType: "image/jpeg",
//         quality: 0.8
//       })
//       .then((result: any) => {
//         const convertedBlob = Array.isArray(result) ? result[0] : result;
//         const convertedFile = new File([convertedBlob], "converted.jpg", {
//           type: "image/jpeg"
//         });
//         processFile(convertedFile);
//       })
//       .catch((err: any) => {
//         console.error("HEIC conversion failed", err);
//         this._notify.error("Failed to convert HEIC image. Please try a different image.");
//       });
//     } else {
//       processFile(file);
//     }
//     event.target.value = null;
//   }
// }

  async onSelectFrame(event: any): Promise<void> {

  if (!(event.target.files && event.target.files[0])) {
    return;
  }

  const file = event.target.files[0];

  const extension = file.name.split('.').pop()?.toLowerCase();
  const mimeType = (file.type || '').toLowerCase();

  const isHeic =
    extension === 'heic' ||
    extension === 'heif' ||
    mimeType.includes('heic') ||
    mimeType.includes('heif');

  const processFile = (f: File) => {

    this.selectedFile_F = f;

    const reader = new FileReader();

    reader.onloadend = () => {
      this.uploadPhotoFrame(reader.result as string);
    };

    reader.readAsDataURL(f);

  };

  try {

    if (isHeic) {

      console.log("HEIC detected");

      const convertedBlob = await heicTo({
        blob: file,
        type: "image/jpeg", // Change to "toType" if your heic-to version requires it
        quality: 0.8
      });

      const convertedFile = new File(
        [convertedBlob as Blob],
        "converted.jpg",
        {
          type: "image/jpeg"
        }
      );

      processFile(convertedFile);

    } else {

      processFile(file);

    }

  } catch (err: any) {

    console.error("HEIC conversion failed", err);

    this._notify.error(
      "Failed to convert HEIC image. Please try a different image."
    );

  }

  // Allow selecting the same file again
  event.target.value = null;

}

  uploadPhotoFrame(newPhoto: string) {
    this.ModelImage_fromPC_F = newPhoto.split(",")[1];
    this.FamilyImage_Frame = this.ModelImage_fromPC_F;
  }

  //Uplaod Image for Chanin
  // onSelectChain(event: any) {
  //   if (event.target.files && event.target.files[0]) {
  //     var reader = new FileReader();
  //     this.selectedFile_C = event.target.files[0];
  //     reader.onloadend = (e) => {
  //       this.uploadPhotChain(reader.result as string);
  //     }
  //     reader.readAsDataURL(event.target.files[0]);
  //   }
  // }

//   onSelectChain(event: any) {
//   if (event.target.files && event.target.files[0]) {
//     let file = event.target.files[0];
//     const isHeic =
//       file.type === "image/heic" ||
//       file.name.toLowerCase().endsWith(".heic");
//       const processFile = (f: File) => {
//         this.selectedFile_C = f;
//         const reader = new FileReader();
//         reader.onloadend = () => {
//           this.uploadPhotChain(reader.result as string);
//         };
//         reader.readAsDataURL(f);
//       };
//       if (isHeic) {
//         (heic2any as any).default({
//           blob: file,
//           toType: "image/jpeg",
//           quality: 0.8
//         })
//         .then((result: any) => {
//           const convertedBlob = Array.isArray(result) ? result[0] : result;
//           const convertedFile = new File([convertedBlob], "converted.jpg", {
//             type: "image/jpeg"
//           });
//           processFile(convertedFile);
//         })
//         .catch((err: any) => {
//           console.error("HEIC conversion failed", err);
//           this._notify.error("Failed to convert HEIC image. Please try a different image.");
//         });
//     } else {
//       processFile(file);
//     }
//     event.target.value = null;
//   }
// }
  async onSelectChain(event: any): Promise<void> {

  if (!(event.target.files && event.target.files[0])) {
    return;
  }

  const file = event.target.files[0];

  const extension = file.name.split('.').pop()?.toLowerCase();
  const mimeType = (file.type || '').toLowerCase();

  const isHeic =
    extension === 'heic' ||
    extension === 'heif' ||
    mimeType.includes('heic') ||
    mimeType.includes('heif');

  const processFile = (f: File) => {

    this.selectedFile_C = f;

    const reader = new FileReader();

    reader.onloadend = () => {
      this.uploadPhotChain(reader.result as string);
    };

    reader.readAsDataURL(f);

  };

  try {

    if (isHeic) {

      console.log("HEIC detected");

      const convertedBlob = await heicTo({
        blob: file,
        type: "image/jpeg", // Change to "toType" if your heic-to version requires it
        quality: 0.8
      });

      const convertedFile = new File(
        [convertedBlob as Blob],
        "converted.jpg",
        {
          type: "image/jpeg"
        }
      );

      processFile(convertedFile);

    } else {

      processFile(file);

    }

  } catch (err: any) {

    console.error("HEIC conversion failed", err);

    this._notify.error(
      "Failed to convert HEIC image. Please try a different image."
    );

  }

  // Allow selecting the same file again
  event.target.value = null;

}

  uploadPhotChain(newPhoto_: string) {
    this.ModelImage_fromPC_C = newPhoto_.split(",")[1];
    this.FamilyImage_Chain = this.ModelImage_fromPC_C;
  }

  //save or Update Family
  save_updateFamily() {
    console.log("this.ShowPropelHrsPerc: ", this.ShowPropelHrsPerc);
    this.setupFamilyService_.savefamilyDetails(this.type_auto, this.FamilyID, this.FamilyName, this.userName, this.blob_auto, this.FamilyImage_Chain, this.FamilyImage_Frame,
      this.ShowDistTravelledTracking, this.ShowPropelHrsPerc, this.ShowEqualiserBarType,
      this.ShowTrackIntensionIndicator, this.showFrameConfiguration, this.showCannonType,
      this.showBogieShim, this.showManualInspection,
      this.showTrackSag, this.showCannonExt, this.showScallop, this.showDryJoints, this.showNumberOfLinks, this.showUnderFootConditions, this.showWorkOrder, this.showThermalImage, this.showAdditionalInspectors).subscribe(result => {
        this.response = result;
        if (this.response.Id != 0) {
          this._notify.error(this.response.Message);
        }
        else {
          this._notify.success('Saved', 'Family Details');
          this.FamilyID = "";
          this.FamilyName = "";
          this.blob_auto = 0;
          this.isNew = true;
          this.setupFamilyService_.getFamilyList();
          this.family = 0;
          this.FamilyImage_Chain = "";
          this.FamilyImage_Frame = "";
          this.ShowDistTravelledTracking = false;
          this.ShowPropelHrsPerc = false;
          this.ShowTrackIntensionIndicator = false;
          this.ShowEqualiserBarType = false;
          this.showFrameConfiguration = false;
          this.showCannonType = false;
          this.showBogieShim = false;
          this.showManualInspection = false;
          this.showTrackSag = false;
          this.showCannonExt = false;
          this.showScallop = false;
          this.showDryJoints = false;
          this.showNumberOfLinks = false;
          this.showUnderFootConditions = false;
          this.showWorkOrder = false;
          this.showThermalImage = false;
          this.showAdditionalInspectors = false;
        }
      })
  }
  response

  delete_family() {
    this.setupFamilyService_.deletfamilyDetails(this.type_auto).subscribe(result => {

      this.response = result;
      if (this.response.Id == -1) {
        this._notify.error(this.response.Message);
      }
      else {
        this._notify.success('Succeed', 'Delete Family Details');
        this.FamilyID = ""
        this.FamilyName = ""
        this.blob_auto = 0
        this.isNew = true
        this.setupFamilyService_.getFamilyList();
        this.family = 0;
        this.FamilyImage_Chain = ""
        this.FamilyImage_Frame = ""
      }
    })
  }
}
